export default __webpack_public_path__ + "static/r-90-3-0554caf134f6c7bcde6521cdac3eda4f.jpg";